<script lang="ts">
    import { theme } from '$theme/theme.svelte';

    import Etihad from '$assets/icons/etihad.svelte';
    import UnitedAirlines from '$assets/icons/united-airlines.svelte';
    import Lufthansa from '$assets/icons/lufthansa.svelte';
    import Jetblue from '$assets/icons/jetblue.svelte';
    import Klm from '$assets/icons/klm.svelte';
    import SingaporeAirlines from '$assets/icons/singapore-airlines.svelte';
    import Eurolines from '$assets/icons/eurolines.svelte';
    import Snbc from '$assets/icons/snbc.svelte';

    export let fill: string;
</script>

<div class="company-container">
    <div class="companies">
        <Etihad
            width={$theme.viewportWidth > 768 ? 91 : 70}
            height={$theme.viewportWidth > 768 ? 33 : 25}
            {fill}
        />

        <UnitedAirlines
            width={$theme.viewportWidth > 768 ? 115 : 85}
            height={$theme.viewportWidth > 768 ? 21 : 15}
            {fill}
        />

        <Lufthansa
            width={$theme.viewportWidth > 768 ? 131 : 98}
            height={$theme.viewportWidth > 768 ? 23 : 17}
            {fill}
        />

        <Eurolines
            width={$theme.viewportWidth > 768 ? 90 : 98}
            height={$theme.viewportWidth > 768 ? 20 : 17}
            {fill}
        />

        <Jetblue
            width={$theme.viewportWidth > 768 ? 101 : 66}
            height={$theme.viewportWidth > 768 ? 35 : 23}
            {fill}
        />

        <Klm
            width={$theme.viewportWidth > 768 ? 85 : 50}
            height={$theme.viewportWidth > 768 ? 49 : 30}
            {fill}
        />

        <SingaporeAirlines
            width={$theme.viewportWidth > 768 ? 123 : 91}
            height={$theme.viewportWidth > 768 ? 45 : 33}
            {fill}
        />

        <Snbc
            width={$theme.viewportWidth > 768 ? 123 : 91}
            height={$theme.viewportWidth > 768 ? 45 : 33}
            {fill}
        />
    </div>
</div>

<style>
    .company-container {
        display: inline-block;
        transform: translateX(0);

        animation-duration: 15s;
        animation-iteration-count: infinite;
        animation-name: move;
        animation-timing-function: linear;
        margin-right: 80px;
    }

    @keyframes move {
        100% {
            transform: translateX(calc(-100% - 80px));
        }
    }

    @keyframes moveTwo {
        100% {
            transform: translateX(calc(-100% - 80px));
        }
    }

    .companies {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 0px var(--spacing-40);
    }
</style>
